import React, { useState, useEffect, useContext } from "react";
import AuthContext from "./AuthContext";
import Nav from "./Nav";
import "./styles/Perfil.css";

function Perfil() {
  const dataToken = useContext(AuthContext);

  const { token, backEnd } = dataToken;
  const [perfilData, setPerfilData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [profilePic, setProfilePic] = useState(null); // Estado para a foto de perfil
  const [medals, setMedals] = useState([]); // Estado para as medalhas do usuário

  // Função para buscar uma imagem aleatória da API Lorem Picsum
  const getRandomProfilePic = async () => {
    try {
      const response = await fetch("https://picsum.photos/200/300", {
        method: "GET",
      });

      if (response.ok) {
        const imageUrl = URL.createObjectURL(await response.blob()); // Cria uma URL para a imagem
        setProfilePic(imageUrl);
      }
    } catch (error) {
      console.error("Erro ao buscar a imagem de perfil:", error);
    }
  };

  // Função para calcular as medalhas com base nos critérios desejados
  function calcularMedalhas(finalTotal, TotalPaginas) {
    const novasMedalhas = [];

    if (finalTotal >= 10) {
      novasMedalhas.push(
        <span key="avid-reader">
          <i className="fa fa-book" aria-hidden="true"></i>{" "}
          Medalha de Leitor Ávido
        </span>
      );
    }

    if (TotalPaginas >= 5000) {
      novasMedalhas.push(
        <span key="intense-reader">
          <i className="fa fa-fire" aria-hidden="true"></i>{" "}
          Medalha de Leitura Intensa
        </span>
      );
    }

    // Medalhas iniciais
    if (finalTotal >= 5) {
      novasMedalhas.push(
        <span key="beginner-reader">
          <i className="fa fa-book" aria-hidden="true"></i>{" "}
          Leitor Iniciante
        </span>
      );
    }

    if (TotalPaginas >= 1000) {
      novasMedalhas.push(
        <span key="book-explorer">
          <i className="fa fa-rocket" aria-hidden="true"></i>{" "}
          Explorador de Livros
        </span>
      );
    }

    return novasMedalhas;
  }

  useEffect(() => {
    // Função para fazer a requisição para o backend
    const fetchPerfilData = async () => {
      try {
        const response = await fetch(backEnd + "/api/perfil", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        });
        if (response.ok) {
          const data = await response.json();
          setPerfilData(data);
          setIsLoading(false);
          getRandomProfilePic(); // Chama a função para buscar uma imagem aleatória

          // Calcule as medalhas com base nos dados do perfil
          const novasMedalhas = calcularMedalhas(data.finalTotal, data.TotalPaginas);
          setMedals(novasMedalhas);
        } else {
          throw new Error("Erro ao carregar os dados do perfil");
        }
      } catch (error) {
        setError(error);
        setIsLoading(false);
      }
    };

    fetchPerfilData();
  }, []);

  if (isLoading) {
    return <p>Carregando...</p>;
  }

  if (error) {
    return <p>Erro: {error.message}</p>;
  }

  if (!perfilData) {
    return <p>Nenhum dado de perfil encontrado.</p>;
  }

  const { perfilName, finalTotal, TotalPaginas } = perfilData;

  return (
    <div>
      <Nav />
      <div className="profile-container">
        <img
          src={profilePic}
          alt="Perfil"
          className="profile-pic"
        />
        <h1>Perfil de Usuário</h1>
        <p>Email: {perfilName[0].username}</p>
        <p>Total de Livros Lidos: {finalTotal}</p>
        
        <p>Total de Paginas Lidas: {TotalPaginas}</p>

        <div className="medals">
          <h2>Medalhas</h2>
          <ul>
            {medals.map((medal, index) => (
              <li key={index}>{medal}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Perfil;
